import {PROPERTY_SELECTOR_SIGIL} from '../constants';

/**
 * Create a function to add to resolvedPropertyMappings with a key and its resolved value
 * The key should look like this: providerComponent@providerProp
 * @param resolvedMappings
 * @returns {(function(*, *): void)}
 */
export default function createAddResolvedPropertyMappingWithKey(resolvedMappings) {
	return function (key, resolvedValue) {
		const [componentId, componentPropName] = key.split(PROPERTY_SELECTOR_SIGIL);
		if (!resolvedMappings.has(componentId)) resolvedMappings.set(componentId, new Map());
		resolvedMappings.get(componentId).set(componentPropName, resolvedValue);
	};
}
